module.exports = __webpack_public_path__ + "static_pc/img/20.432f69e8.png";